import { render } from "./replacement_uploader.vue?vue&type=template&id=0d8686eb"
import script from "./replacement_uploader.vue?vue&type=script&lang=js"
export * from "./replacement_uploader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
var __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__